import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

import { ReactivateSubscriptionPage } from './reactivate-subscription.page';
import { SquadCastComponentsModule } from '../../components/squadcast.components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild([
      {
        path: '',
        component: ReactivateSubscriptionPage,
      },
    ]),
    SquadCastComponentsModule,
  ],
  declarations: [ReactivateSubscriptionPage],
})
export class ReactivateSubscriptionPageModule {}
